import { createContext, useContext } from 'react';

// For more details on aria props that the input area needs to implement, see
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-autocomplete
export interface EditorContextOptions {
  readonly 'aria-autocomplete': 'list' | undefined;
  readonly 'aria-controls': string | undefined;
  readonly 'aria-activedescendant': string | undefined;
}

const defaultEditorContextOptions: EditorContextOptions = {
  'aria-autocomplete': undefined,
  'aria-controls': undefined,
  'aria-activedescendant': undefined,
};

export const EditorContext = createContext<EditorContextOptions>(defaultEditorContextOptions);

export type UseEditorContext = () => EditorContextOptions;
export const useEditorContext: UseEditorContext = () => useContext(EditorContext);
